// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___iTbmw","container_1":"container_1___sl-Nj","container_2":"container_2___1i6g9"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CIBC/styles.module.scss
// module id = 737
// module chunks = 0